import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { ConfigSettingsService, wait } from '@ebeihilfe/core';
import { EdgeToEdge } from '@capawesome/capacitor-android-edge-to-edge-support';
import { Injectable, inject } from '@angular/core';
import { StatusBar, Style } from '@capacitor/status-bar';

@Injectable({
  providedIn: 'root',
})
export class StatusBarService {
  private readonly defaultColor = '#f4f5f8';
  private readonly defaultColorDark = '#222428';
  private readonly configService = inject(ConfigSettingsService);

  public async initialize(): Promise<void> {
    if (Capacitor.getPlatform() === 'android') {
      await this.initColorSchemeListener();
      await this.setStatusBarColorBasedOnColorScheme();
    }
  }

  private async setStatusBarColorBasedOnColorScheme(): Promise<void> {
    const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
    let color = this.defaultColorDark;
    const forceStatusBarDarkStyle =
      this.configService.appSettings.customizing?.appContent?.forceStatusBarDarkStyle ?? false;
    if (!isDarkMode) {
      color = this.configService.appSettings.customizing?.appContent?.statusBarBackgroundColor ?? this.defaultColor;
    }
    const style = isDarkMode || forceStatusBarDarkStyle ? Style.Dark : Style.Light;
    await EdgeToEdge.setBackgroundColor({ color });
    await wait(300);
    await StatusBar.setStyle({ style });
  }

  private async initColorSchemeListener(): Promise<void> {
    App.addListener('resume', async () => {
      await this.setStatusBarColorBasedOnColorScheme();
    });
  }
}
